<template>
    <div>

        <config-main-title>
            Ofertas Particulares
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="row mb-3">
                <div class="col col-12 col-md-6 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir Oferta
                    </button>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhuma Oferta Particular identificada.'" 
                icon="fa-solid fa-envelope-open-dollar"
                :action="'Incluir Oferta'" 
                :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between hover-bg" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>
                        <span class="badge badge-secondary mr-2">
                            #{{ dado.id_oferta_particular }}
                        </span>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" :id="'ativo-' + id" v-model="dado.fl_ativo" @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <div class="d-flex" v-else>
                            
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ item && item.id_oferta_particular ? '' : 'Nova' }}
                            Oferta Particular
                            <span class="badge badge-secondary ml-2" v-if="item.id_oferta_particular">
                                #{{ item.id_oferta_particular }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    placeholder="Informe o título da oferta..."
                                    label="Título"
                                    :validate="validate"
                                    required
                                    v-model="item.st_titulo" />
                            </div>
                        </div>

                        <div class="form-row" v-if="false">
                            <div class="col col-12 col-md-3">
                                <az-input
                                    sizing="sm"
                                    label="Vigência Inicial"
                                    type="date"
                                    :validate="validate"
                                    required
                                    v-model="item.dt_inicio_vigencia" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    sizing="sm"
                                    label="Vigência Final"
                                    type="date"
                                    :validate="validate"
                                    required
                                    v-model="item.dt_final_vigencia" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12">
                                <az-input 
                                    label="Plano Particular de Cobrança"
                                    sizing="sm"
                                    placeholder="Plano Particular de Cobrança..."
                                    type="select" 
                                    optionsMode="aql"
                                    optionsName="planos.particular.cobranca"
                                    :optionsParm="{ 
                                        id_operadora: 1, 
                                    }"
                                    service="planos.index"
                                    optionsData="id_plano"
                                    :optionsSync="false"
                                    required
                                    :validate="validate"
                                    v-model="item.id_plano">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append" v-if="item.id_plano">
                                            <span class="input-group-text">#{{ item.id_plano }}</span>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-3">
                                <az-input
                                    sizing="sm"
                                    type="number"
                                    label="Ordem"
                                    placeholder="Informar..."
                                    v-model="item.in_ordem" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    sizing="sm"
                                    type="number"
                                    label="Idade Mínima do Paciente"
                                    placeholder="0"
                                    v-model="item.in_idade_min" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    sizing="sm"
                                    type="number"
                                    label="Idade Máxima do Paciente"
                                    placeholder="999"
                                    v-model="item.in_idade_max" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    sizing="sm"
                                    type="sexo"
                                    placeholder="Qualquer"
                                    label="Sexo do Paciente"
                                    v-model="item.ch_sexo" />
                            </div>
                        </div>

                        <az-sub-title title="Instruções da Oferta" />
                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Layout em HTML"
                                    :validate="validate"
                                    v-model="item.fl_info_html" />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    type="textarea"
                                    rows="5"
                                    required
                                    :validate="validate"
                                    v-model="item.st_info" />
                            </div>
                        </div>

                        <!-- Filtros -->
                        <filtro-model class="my-3" v-model="item.filtros" :validate="validate" :opcoes="lista_opcoes_filtro" />
                        
                        <div class="mb-3">
                            <az-sub-title title="Procedimentos" v-if="item.items">
                                <a class="card-link" href="#" @click.prevent="incluir_procedimento()">
                                    <i class="fas fa-plus mr-2"></i>
                                    Incluir
                                </a>
                            </az-sub-title>

                            <div v-if="item.items && !item.items.length">
                                Nenhum procedimento relacionado
                            </div>

                            <div v-else>
                                <div v-for="(proced, ipx) in item.items" :key="ipx">
                                    <div class="form-row" v-if="!proced.excluido">
                                        <div class="col col-12">
                                            <az-input
                                                :label="ipx ? '' : 'Procedimento'"
                                                v-if="!proced.procedimento"
                                                placeholder="Selecione o Procedimento..."
                                                sizing="sm"
                                                type="autocomplete"
                                                :service="'procedimentos.index'"
                                                optionsName="'procedimentos.oferta.particular'"
                                                :optionsParm="{ ativos: true }"
                                                required
                                                v-model="proced.procedimento">
                                                <template v-slot:button-pre>
                                                    <div class="input-group-prepend">
                                                        <button class="btn btn-outline-danger" type="button" @click="proced.excluido = true">
                                                            <i class="fa fa-minus" aria-hidden="true"></i>
                                                        </button>
                                                    </div>
                                                </template>
                                            </az-input>

                                            <az-input
                                                v-else
                                                :label="ipx ? '' : 'Procedimento'"
                                                sizing="sm"
                                                :edicao="false"
                                                :value="proced.procedimento.search">
                                                <template v-slot:button-pre>
                                                    <div class="input-group-prepend">
                                                        <button class="btn btn-outline-danger" type="button" @click="proced.excluido = true">
                                                            <i class="fa fa-minus" aria-hidden="true"></i>
                                                        </button>
                                                    </div>
                                                </template>
                                            </az-input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <az-sub-title title="Observações" />
                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    type="textarea"
                                    rows="3"
                                    :validate="validate"
                                    v-model="item.st_obs" />
                            </div>
                        </div>

                        <br><br><br><br><br><br><br><br><br><br>

                        <pre v-if="1==0">{{ item }}</pre>
                    </div>
                    <div class="modal-footer">
                        <az-submit color="outline-secondary" @click="clonar()" v-if="false && item.id_oferta_particular">
                            Clonar
                        </az-submit>
                        <az-audit-log-button model="ofertaParticular" :id="item.id_oferta_particular" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_oferta_particular ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import FiltroModel from '../shared/FiltroModel.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            filtro: { 
                periodo: 'm', 
            },
            edicao_datas: null, 
            edicao_data: null,
        }
    },

    props: ['cadastro'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzSubTitle,
        AzAuditLogButton,
        FiltroModel, 
        AzPeriodo
    },

    computed: { 
        lista_filtros: function () { 

            if ( !this.item ) 
                return [];

            return this.item.filtros.filter(item => !item.excluido);

        },

        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            if ( this.edicao_datas ) {
                return [ 
                    this.edicao_datas, 
                ];
            }

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },

        lista_opcoes_filtro: function () { 
            let opcoes = [                        
                {id:'App\\azure\\apoiado', search:'Apoiado', service: 'apoiados.index'},
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
                {id:'App\\azure\\operadora', search:'Operadora', service: 'operadoras.index'}, 
                {id:'App\\azure\\medico', search:'Prestador', service: 'medicos.index'},
            ];

            if ( this.$store.state.unidade.unidade_operacaos.length > 1 ) { 
                opcoes.push({id:'App\\azure\\unidadeOperacao', search:'Unidade', service:'unidade_operacaos.index'});
            }
            
            return opcoes;
        }
    },

    methods: { 
        incluir_procedimento () { 
            this.item.items.push({
                id_procedimento: null,
                procedimento: "", 
                excluido: false, 
            });
        },

        
        clonar() { 
            if ( !confirm ("Confirma clonar o item '" + this.item.st_titulo + "'?") )
                return;

            this.$util.atualizar(this, { 
                service: 'cadastros',
                func: 'clonar',
                dados: { 
                    model: 'ofertaParticular',
                    id: this.item.id_oferta_particular,
                },
                modal: 'edicaoModal',
                toast: true, 
                reload: true, 
            });
        },

        incluir_filtro(item) { 
            item.filtros.push({ 
                origem_type: 'App\\azure\\ofertaParticular',
                origem_id: this.item.id_oferta_particular,
                model_type: "",
                model_id: "",
                model: "", 
                service: "", 
                fl_regra: true, 
                excluido: false, 
            });
        },

        incluir () { 
            this.validate = false;
            this.item = null; 

            this.$nextTick(() => { 
                this.item = {
                    id_oferta_particular: null, 
                    dt_inicio_vigencia: this.$util.hoje(), 
                    dt_fim_vigencia: "", 
                    st_info: "",
                    st_obs: "",
                    st_titulo: "", 
                    fl_ativo: true,
                    filtros: [],
                    items: [], 
                    st_sexo: null,
                    in_idade_min: null,
                    in_idade_max: null,
                    in_ordem: 100, 
                    fl_info_html: false, 
                    id_plano: "", 
                };

                $('#edicaoModal').modal('show');
            }); 
        },
        load () { 
            this.$util.load(this, { 
                service:'ofertas_particulares',
                func: 'index',
                parms: { 
                    cadastro: true, 
                },
            });
        },
        editar (item) { 
            this.item = null; 
            this.validate = false; 

            this.$nextTick(() => { 

                this.$util.load(this, { 
                    service:'ofertas_particulares',
                    func: 'show',
                    parms: { 
                        id: item.id_oferta_particular,
                        cadastro: true, 
                        edicao: true, 
                    },
                    loadTo: res => { 
                        this.item = res; 
                        $('#edicaoModal').modal('show');    
                    }
                });

            });
        },

        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'ofertas_particulares',
                dados: this.item,
                reload: true, 
                modal: 'edicaoModal',
            });
        },

        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },

        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'ofertas_particulares',
                dados: item,
            });

        },
    },

    mounted () { 
        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Ofertas Particulares", method: this.fechar },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }

}
</script>